import { Cultures } from '@ideals/types';

export const LANGUAGES = [
  {
    id: Cultures.US,
    caption: 'English (United States)',
  },
  {
    id: Cultures.CN,
    caption: '中文 (中国)',
  },
  {
    id: Cultures.DE,
    caption: 'Deutsch (Deutschland)',
  },
  {
    id: Cultures.SE,
    caption: 'Svenska (Sverige)',
  },
  {
    id: Cultures.FR,
    caption: 'Français (France)',
  },
  {
    id: Cultures.ES,
    caption: 'Español (España, Alfabetización Internacional)',
  },
  {
    id: Cultures.BR,
    caption: 'Português (Brasil)',
  },
  {
    id: Cultures.IT,
    caption: 'Italiano (Italia)',
  },
  {
    id: Cultures.NL,
    caption: 'Nederlands (Nederland)',
  },
  {
    id: Cultures.JP,
    caption: '日本語 (日本)',
  },
  {
    id: Cultures.KR,
    caption: '한국어 (대한민국)',
  },
  {
    id: Cultures.TR,
    caption: 'Türkçe (Türkiye)',
  },
  {
    id: Cultures.PL,
    caption: 'Polski (Polska)',
  },
  {
    id: Cultures.RU,
    caption: 'Русский (Россия)',
  },
  {
    id: Cultures.UA,
    caption: 'Українська (Україна)',
  },
];
